import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["notifyToggleHideShow", "hideButtonText", "showButtonText", "filterFunction", "data"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { defaultMemoize } from 'reselect';
import _identity from 'lodash/identity';
import _noop from 'lodash/noop';
import _size from 'lodash/size';
import { EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';
import Button from '../../../../atoms/Button';
import PropertyControlledComponent from '../../../PropertyControlledComponent';
import styles from './withHideShowEntries.module.scss';
export default function withHideShowEntries(Component) {
  var _class;
  return _class = /*#__PURE__*/function (_React$PureComponent) {
    _inherits(withHideShowEntriesComponent, _React$PureComponent);
    var _super = _createSuper(withHideShowEntriesComponent);
    function withHideShowEntriesComponent(_props) {
      var _this;
      _classCallCheck(this, withHideShowEntriesComponent);
      _this = _super.call(this, _props);
      _defineProperty(_assertThisInitialized(_this), "determineShouldShowFilter", function () {
        var _this$props = _this.props,
          data = _this$props.data,
          filterFunction = _this$props.filterFunction;
        var filteredValues = filterFunction(data);
        _this.setState({
          shouldShowFilterButton: filteredValues.length !== data.length
        });
      });
      _defineProperty(_assertThisInitialized(_this), "triggerNotifyToggleHideShow", function () {
        var shouldFilter = _this.state.shouldFilter;
        var notifyToggleHideShow = _this.props.notifyToggleHideShow;
        notifyToggleHideShow(shouldFilter);
      });
      _defineProperty(_assertThisInitialized(_this), "onToggleHideShowData", function () {
        var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props;
        _this.setState(function (_ref) {
          var prevShouldFilter = _ref.shouldFilter;
          return {
            shouldFilter: !prevShouldFilter,
            hideShowButtonText: prevShouldFilter ? props.hideButtonText : props.showButtonText
          };
        }, _this.triggerNotifyToggleHideShow);
      });
      _this.filterFunction = defaultMemoize(_props.filterFunction);
      _this.state = {
        shouldFilter: true,
        shouldShowFilterButton: false,
        hideShowButtonText: _props.showButtonText
      };
      return _this;
    }
    _createClass(withHideShowEntriesComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.determineShouldShowFilter();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var data = this.props.data;
        var prevData = prevProps.data;
        if (data !== prevData) this.determineShouldShowFilter();
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
          notifyToggleHideShow = _this$props2.notifyToggleHideShow,
          hideButtonText = _this$props2.hideButtonText,
          showButtonText = _this$props2.showButtonText,
          filterFunction = _this$props2.filterFunction,
          data = _this$props2.data,
          tableProps = _objectWithoutProperties(_this$props2, _excluded);
        var _this$state = this.state,
          shouldFilter = _this$state.shouldFilter,
          hideShowButtonText = _this$state.hideShowButtonText,
          shouldShowFilterButton = _this$state.shouldShowFilterButton;
        var filteredValues = shouldFilter ? this.filterFunction(data) : data;
        return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Component, _extends({}, tableProps, {
          data: filteredValues,
          pageSize: _size(filteredValues)
        })), /*#__PURE__*/React.createElement(PropertyControlledComponent, {
          controllerProperty: shouldShowFilterButton
        }, /*#__PURE__*/React.createElement(Button, {
          view: Button.VIEW.TERTIARY,
          className: styles.hideShowButton,
          onClick: this.onToggleHideShowData
        }, hideShowButtonText)));
      }
    }]);
    return withHideShowEntriesComponent;
  }(React.PureComponent), _defineProperty(_class, "propTypes", {
    hideButtonText: PropTypes.string.isRequired,
    showButtonText: PropTypes.string.isRequired,
    data: PropTypes.array,
    filterFunction: PropTypes.func,
    notifyToggleHideShow: PropTypes.func
  }), _defineProperty(_class, "defaultProps", {
    filterFunction: _identity,
    data: EMPTY_ARRAY,
    notifyToggleHideShow: _noop
  }), _class;
}